export default function capitalize(type){
  return type.substr(0, 1).toUpperCase() + type.substr(1)
}
